export const UPDATE_PLAN_TYPE = 'UPDATE_PLAN_TYPE'
export const UPDATE_SOLUTION_TYPE = 'UPDATE_SOLUTION_TYPE'
